export default "__VITE_ASSET__BlEDTqeN__"